export type Usuario = {
  id: number,
  username: string,
  email: string,
  accessToken?: string,
  tokenType: string,
  roles?: string[],
  userId: number,
}

export enum ROLES {
  USER_ADMIN = 'USER_ADMIN',
  COLABORADOR = 'COLABORADOR',
  GESTOR = 'GESTOR'
}
